import Plyr from 'plyr';

export default class Video {
    constructor() {
        console.log('%c👍🏼 Video', 'color: yellow');
        this.videos = document.querySelectorAll('.plyr__video__wrapper');
    }
    init() {
        const videoModal = document.getElementById('video-modal-player');
        const pageVideo = document.getElementById('video-scrolling-text-inline-video');
        if (!videoModal) {
            console.error('No video modal found');
            return;
        }

        if (!pageVideo) {
            console.error('No page video found');
            return;
        }
        
        const pageVideoPlayer = new Plyr(pageVideo, {
            loop: { active: true },
            autoplay: true,
            youtube: { 
                autoplay: true,
                noCookie: true,
                rel: 0, 
                showinfo: 0, 
                iv_load_policy: 3, 
                modestbranding: 1 
            },
            vimeo: {
                muted: true
            },
            muted: true
        }); 
        const modalVideoPlayer = new Plyr(videoModal, {
            youtube: { 
                noCookie: true,
                rel: 0, 
                showinfo: 0, 
                iv_load_policy: 3, 
                modestbranding: 1 
            },
            vimeo: {
                muted: true
            },
            muted: true
        }); 

        pageVideoPlayer.on('ready', () => {

            if(pageVideo.classList.contains('video__muted')) {
                console.log('muted viedeo');
                pageVideoPlayer.muted = true;
                pageVideoPlayer.volume = 0;
            } else {
                console.log('unmuted viedeo');
                pageVideoPlayer.muted = false;
                pageVideoPlayer.volume = 5;
            }

            pageVideoPlayer.play();
        });

        this.addModalEvents(pageVideoPlayer, modalVideoPlayer);
    }



    addModalEvents(pageVideoPlayer, modalVideoPlayer) {
        const videoModal = document.getElementById('video-modal');
        if (!videoModal) {
            return;
        }
        
        videoModal.addEventListener('show.bs.modal', () => {
            pageVideoPlayer.pause();

            modalVideoPlayer.volume = 1;
            modalVideoPlayer.muted = false;
            modalVideoPlayer.play();
        });

        videoModal.addEventListener('hide.bs.modal', () => {
            modalVideoPlayer.pause();

            pageVideoPlayer.muted = true;
            pageVideoPlayer.volume = 0;
            pageVideoPlayer.play();
        });
    }
}